import React, {memo} from 'react';
import {PlacementType, Referral, ReferralAuthorizedHours, ServiceType} from 'referral';

type Props = {
    referral: Pick<Referral, 'placementType' | 'serviceTypes'> & ReferralAuthorizedHours;
}
export const ReferralHoursRenderer = memo(({referral}: Props) => {
    if (referral.placementType === PlacementType.Treatment_Only ||
        referral.placementType === PlacementType.Assessment_with_Concurrent_Treatment) {
        return (
            <div className="pb-5">
                <AuthorizedHoursRenderer referral={referral}/>
            </div>
        );
    } else {
        return <></>;
    }
});


const AuthorizedHoursRenderer = memo(({referral}: Props) => {
    return (
        <>
            <div className='font-semibold pb-5'>
                Clinical Recommendation
            </div>
            {includePsychotherapyServiceType(referral.serviceTypes) ? psychotherapyHoursRender(referral) : defaultContentRender(referral)}
        </>
    );
});

const defaultContentRender = (referral: Pick<Referral, 'placementType' | 'serviceTypes'> & ReferralAuthorizedHours) => {
    const hasGroup = referral.serviceTypes.includes(ServiceType.Group_ABA) || referral.serviceTypes.includes(ServiceType.Social_Skills_Group);
    return (

        <>
            <div className='flex pb-2'>
                <div className='italic'>
                    Caregiver Mediated Treatment
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    Mid Level
                </div>
                <div className='w-1/2'>
                    {referral.careMediatedMidMinHours == null? '' : referral.careMediatedMidMinHours} - {referral.careMediatedMidHours == null? '' : referral.careMediatedMidHours} hours per month
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    High Level
                </div>
                <div className='w-1/2'>
                    {referral.careMediatedHighMinHours == null? '' : referral.careMediatedHighMinHours} - {referral.careMediatedHighHours == null? '' : referral.careMediatedHighHours} hours per month
                </div>
            </div>

            <div className='flex pb-2 mt-2'>
                <div className='italic'>
                    Practitioner Mediated Treatment
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    Paraprofessional
                </div>
                <div className='w-1/2'>
                    {referral.practDirectBeneficialHours == null? '' : referral.practDirectBeneficialHours} - {referral.practDirectOptimalHours == null? '' : referral.practDirectOptimalHours} hours per month
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    Mid Level
                </div>
                <div className='w-1/2'>
                    {referral.practMidBeneficialHours == null? '' : referral.practMidBeneficialHours} - {referral.practMidOptimalHours == null? '' : referral.practMidOptimalHours} hours per month
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    High Level
                </div>
                <div className='w-1/2'>
                    {referral.practHighBeneficialHours == null? '' : referral.practHighBeneficialHours} - {referral.practHighOptimalHours == null? '' : referral.practHighOptimalHours} hours per month
                </div>
            </div>
            {hasGroup &&
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Group Care
                    </div>
                    <div className='w-1/2'>
                        {referral.practGroupBeneficialHours == null ? '' : referral.practGroupBeneficialHours} - {referral.practGroupOptimalHours == null ? '' : referral.practGroupOptimalHours} hours per month
                    </div>
                </div>
            }
            <div className="pt-2 pl-1 italic">
                *Paraprofessional Hours are required only if Practitioner Mediated Service will be provided.
            </div>
        </>
    );
}

const psychotherapyHoursRender = (referral: Pick<Referral, 'placementType' | 'serviceTypes'> & ReferralAuthorizedHours) => {
    if ((referral.authTherapyTreatmentUnitsPer == null || referral.authTherapyTreatmentUnitsPer === "") ||
        (referral.authTherapyTreatmentUnitType == null || referral.authTherapyTreatmentUnitType === "") ||
         referral.authTherapyTreatmentUnit == null) {
        return <div>None</div>
    }
    return <div>
        {`${referral.authTherapyTreatmentUnit} ${referral.authTherapyTreatmentUnitType} per ${referral.authTherapyTreatmentUnitsPer}`}
    </div>
}
const includePsychotherapyServiceType = (serviceTypes: ServiceType[]) => serviceTypes.includes(ServiceType.Compass_Psychotherapy) || serviceTypes.includes(ServiceType.Psychotherapy);
